import { Divider, IconButton, List, ListItem, ListItemText, Typography } from "@mui/material";
import { Fragment, useCallback } from "react";
import { useCompanyCore } from "../../../../core/modules/company";
import { useTranslation } from "react-i18next";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { CREATE_METRIC_DIALOG } from "../../../../core/constants/dialog";
import { useGlobalCore } from "../../../../core/modules/global";
import { MetricType } from "../../../../core/interfaces/metricType.interface";
import { useMetricsCore } from "../../../../core/modules/metrics";

const MetricsTab = () => {
  const { t } = useTranslation();
  const { metricTypes, setMetricType } = useMetricsCore();
  const { openDialog } = useGlobalCore();

  const onEditing = useCallback((metric: MetricType) => {
    setMetricType(metric);
    openDialog(CREATE_METRIC_DIALOG);
  }, [openDialog, setMetricType]);
  

  return (
    <div className="bg-white">
      {metricTypes.map((metric) => (
        <div key={metric.id}>
          <Divider />
          <ListItem
            className="px-32 py-16"
            sx={{ bgcolor: 'background.paper' }}
            secondaryAction={
              <IconButton aria-label="edit" color="primary" onClick={() => onEditing(metric)}>
                <EditOutlinedIcon /> 
              </IconButton>
            }
          >
            <ListItemText
              classes={{
                root: 'm-0',
                primary: 'font-medium leading-5 truncate',
              }}
              primary={metric.name}
              secondary={
                <Fragment>
                  <Typography
                    component="div"
                    variant="body2"
                    color="text.primary"
                  >
                    {metric.shortName}
                  </Typography>
                  <Typography
                    component="div"
                    variant="body2"
                    color="text.secondary"
                  >
                    {metric.metricId}
                  </Typography>
                </Fragment>
              }
            />
          </ListItem>
        </div>
      ))}
      <Divider />
    </div>
  );
};

export default MetricsTab;